export default __webpack_public_path__ + "static/media/petFooter.770a3fca.png";